// extracted by mini-css-extract-plugin
module.exports = {"root__div":"Root_root__div__1rpAh","main":"Root_main__164bu"};